export default "__VITE_ASSET__32148b4d__"